import Loading from "components/pages/loading";
import {useEdit as useForm} from "lib/hooks/use-form";
import Form from "./form";

export default function Edit() {
  const {onChange, onSubmit, record, value} = useForm({withFiles: true, url: "/api/admin/users/:id"});
  if(!record) { return <Loading />; }

  return (
    <div className="container">
      <h1 className="text-center">Edit User</h1>
      <Form onChange={onChange} onSubmit={onSubmit} value={value} />
    </div>
  );
}
